import useSWR from 'swr';
import { useCallback, useContext, useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '@arionbanki/arionui';
import { AppContext } from 'providers/AppProvider';
import { isValidKennitala } from 'helpers';

export function SSNInput(props: Readonly<TextFieldProps>) {
	const { defaultValue } = props;
	const { config, t } = useContext(AppContext);
	const { API } = config;
	const [error, setError] = useState(!!props.error);
	const [message, setMessage] = useState('');
	const defaultURL = isValidKennitala(defaultValue) ? `${API.nationalRegistry}/${defaultValue}` : null;
	const [url, setURL] = useState<string | null>(defaultURL);
	const { data } = useSWR<{ isCompany: boolean; name: string }>(url);

	const handleChange = useCallback(
		(e: any) => {
			if (isValidKennitala(e?.target?.value)) {
				setURL(`${API.nationalRegistry}/${e.target.value}`);
			} else {
				setMessage('');
				setError(false);
			}
		},
		[API.nationalRegistry]
	);

	useEffect(() => {
		if (data) {
			if (!data.name) {
				setMessage(t('error_ssn_not_found', 'mandate'));
				setError(true);
			} else if (data.isCompany) {
				setMessage(t('error_company', 'mandate'));
				setError(true);
			} else {
				setMessage(data.name);
				setError(false);
			}
		}
	}, [data, t]);

	useEffect(() => {
		props.error && setError(true);
	}, [props.error]);

	return <TextField {...props} error={error} message={message} onChange={handleChange} />;
}
